import { Container, Flex, Heading, Section } from '@radix-ui/themes'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { DEFAULT_STALE_DATA_TIMEOUT } from '@AppState/app-config'
import { RootState } from '@AppState/redux-store'
import { PamVerificationServiceAPI } from '@API/data-services/pam-verification-service'
import { PamDocumentQueueSummary } from '@Generated/back-office-client/src'
import { Routes } from '@Components/main-app/types'
import { usePaginatedState } from '@Components/common/use-paginated-state'
import { PamDocumentQueueView } from './pam-document-queue-view'

const PAGE_SIZE = 50

export const PamDocumentQueue = () => {
  const { activeCustomerId } = useSelector((state: RootState) => state.users)
  const nav = useNavigate()
  const location = useLocation()
  const [currentPage, setCurrentPage] = usePaginatedState()

  const { data, isLoading } = useQuery({
    queryKey: [`${activeCustomerId}-pam-document-queue`, currentPage],
    staleTime: DEFAULT_STALE_DATA_TIMEOUT,
    queryFn: () => {
      return PamVerificationServiceAPI.listDocumentQueue({
        resultStart: currentPage * PAGE_SIZE,
        resultEnd: currentPage * PAGE_SIZE + PAGE_SIZE,
      })
    },
  })

  const currentQueueHref = `${Routes.PAM_VERIFICATIONS}${location.search}`

  const onRowClick = (row: PamDocumentQueueSummary) => {
    nav(Routes.PAM_VERIFICATION_DETAIL.replace(':pamPlayerId', row.pamPlayerId), {
      state: { from: currentQueueHref },
    })
  }

  return (
    <Container>
      <Section>
        <Flex direction="column" gap="4">
          <Heading size="6">Document Review Queue</Heading>
          <PamDocumentQueueView
            page={data}
            pageSize={PAGE_SIZE}
            currentPage={currentPage}
            isLoading={isLoading}
            onPageChange={setCurrentPage}
            onRowClick={onRowClick}
          />
        </Flex>
      </Section>
    </Container>
  )
}
